var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.343 3.757l1.414-1.414 9.9 9.9-1.415 1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.243 2.343l1.414 1.414-9.9 9.9-1.413-1.414z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi4zNDMzOCIgeT0iMy43NTczMiIgd2lkdGg9IjIiIGhlaWdodD0iMTQiIHRyYW5zZm9ybT0icm90YXRlKC00NSAyLjM0MzM4IDMuNzU3MzIpIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMTIuMjQyOCIgeT0iMi4zNDMyNiIgd2lkdGg9IjIiIGhlaWdodD0iMTQiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEyLjI0MjggMi4zNDMyNikiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgCloses as ReactComponent };